import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {HoopsPropTypes} from '../../componentsLib';
import {fullName} from '../../utils';
import {useMountEffect} from '../../hooks';

const APP_ID = process.env.REACT_APP_INTERCOM_ID;

export function Intercom({anon, children}) {
  const [intercomReady, setIntercomReady] = useState(!!window.Intercom);
  const {isLoggedIn, userData: user} = useSelector((state) => state.authReducer);

  useMountEffect(() => {
    if (!intercomReady) {
      initIntercom(() => setIntercomReady(true));
    }
  });

  useEffect(() => {
    if (!intercomReady || !window.Intercom) {
      return undefined;
    }

    if (anon || !isLoggedIn || !user?._id) {
      Object.assign(window.intercomSettings ?? {}, {app_id: APP_ID});
      window.Intercom('boot', {app_id: APP_ID});
    } else {
      Object.assign(window.intercomSettings ?? {}, {
        app_id: APP_ID,
        user_id: user._id,
        name: fullName(user),
        email: user.username,
        intercom_user_jwt: user.jwtToken,
      });
      window.Intercom('boot', {
        app_id: APP_ID,
        user_id: user._id,
        name: fullName(user),
        email: user.username,
        intercom_user_jwt: user.jwtToken,
      });
    }
    return (() => {
      window.Intercom('shutdown');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, user._id, intercomReady]);

  return children ?? null;
}

Intercom.propTypes = {
  anon: HoopsPropTypes.bool,
  children: HoopsPropTypes.children,
};

function initIntercom(onLoaded) {
  if (!window.Intercom) {
    const scriptEl = document.createElement('script');
    scriptEl.onload = onLoaded;
    scriptEl.type = 'text/javascript';
    scriptEl.async = true;
    scriptEl.src = `https://widget.intercom.io/widget/${APP_ID}`;
    const scripts = document.getElementsByTagName('script')[0];
    scripts.parentNode.insertBefore(scriptEl, scripts);
  }
}
